var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exerland"},[_c('keep-alive',[(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e(),_c('van-overlay',{staticClass:"videoBox",attrs:{"show":_vm.show},on:{"click":_vm.closeBigScreen}},[(_vm.show)?_c('div',{ref:"video",attrs:{"id":"video"}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }